(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nh-announce"] && !Shopify.designMode) return;
  try {
    
(function(){
  var bar = document.querySelector('[data-nh-announce]');
  if(!bar) return;
  var msgs = bar.querySelectorAll('.nh-announce__msg');
  if(msgs.length < 2) return;
  var i = 0;
  setInterval(function(){
    msgs[i].classList.remove('is-active');
    i = (i + 1) % msgs.length;
    msgs[i].classList.add('is-active');
  }, 3500);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nh-nav"] && !Shopify.designMode) return;
  try {
    
(function(){
  var nav = document.querySelector('[data-nh-nav]');
  if(nav){
    var threshold = 40;
    function onScroll(){
      if(window.scrollY > threshold){ nav.classList.add('is-scrolled'); }
      else { nav.classList.remove('is-scrolled'); }
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  var drawer = document.querySelector('[data-nh-drawer]');
  if(drawer){
    var openers = document.querySelectorAll('[data-nh-drawer-open]');
    var closers = document.querySelectorAll('[data-nh-drawer-close]');
    function openDrawer(){
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden','false');
      document.body.style.overflow = 'hidden';
      openers.forEach(function(b){ b.setAttribute('aria-expanded','true'); });
    }
    function closeDrawer(){
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden','true');
      document.body.style.overflow = '';
      openers.forEach(function(b){ b.setAttribute('aria-expanded','false'); });
    }
    openers.forEach(function(b){ b.addEventListener('click', openDrawer); });
    closers.forEach(function(b){ b.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nh-pdp-carousel"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.querySelector('[data-nh-car]');
  if(!root) return;
  var track = root.querySelector('[data-nh-car-track]');
  var slides = track ? track.children : [];
  var dots = root.querySelectorAll('[data-nh-car-dot]');
  var prev = root.querySelector('[data-nh-car-prev]');
  var next = root.querySelector('[data-nh-car-next]');
  if(!track || !slides.length) return;
  var i = 0;
  function go(n){
    i = (n + slides.length) % slides.length;
    track.style.transform = 'translateX(-' + (i * 100) + '%)';
    dots.forEach(function(d, idx){ d.classList.toggle('is-active', idx === i); });
  }
  prev && prev.addEventListener('click', function(){ go(i - 1); });
  next && next.addEventListener('click', function(){ go(i + 1); });
  dots.forEach(function(d){ d.addEventListener('click', function(){ go(parseInt(d.dataset.i, 10)); }); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nh-pdp-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  var thumbs = document.querySelectorAll('[data-nh-thumb]');
  var main = document.querySelector('.nh-pdp-hero__img');
  if(!main || !thumbs.length) return;
  thumbs.forEach(function(t){
    t.addEventListener('click', function(){
      thumbs.forEach(function(x){x.classList.remove('is-active');});
      t.classList.add('is-active');
      main.src = t.dataset.src;
      main.srcset = '';
    });
  });
})();

(function(){
  var idInput = document.querySelector('[data-nh-id]');
  var radios = document.querySelectorAll('[data-nh-variant]');
  if(!idInput || !radios.length) return;
  var pOne = document.querySelector('[data-nh-price-onetime]');
  var pSub = document.querySelector('[data-nh-price-sub]');
  radios.forEach(function(r){
    r.addEventListener('change', function(){
      idInput.value = r.value;
      if(pOne && r.dataset.onetime) pOne.textContent = r.dataset.onetime;
      if(pSub && r.dataset.sub) pSub.textContent = r.dataset.sub;
      document.querySelectorAll('.nh-pdp-hero__variant').forEach(function(l){ l.classList.remove('is-active'); });
      var lab = r.closest('.nh-pdp-hero__variant'); if(lab) lab.classList.add('is-active');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nh-pdpv2-carousel"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.querySelector('[data-nh-car]');
  if(!root) return;
  var track = root.querySelector('[data-nh-car-track]');
  var slides = track ? track.children : [];
  var dots = root.querySelectorAll('[data-nh-car-dot]');
  var prev = root.querySelector('[data-nh-car-prev]');
  var next = root.querySelector('[data-nh-car-next]');
  if(!track || !slides.length) return;
  var i = 0;
  function go(n){
    i = (n + slides.length) % slides.length;
    track.style.transform = 'translateX(-' + (i * 100) + '%)';
    dots.forEach(function(d, idx){ d.classList.toggle('is-active', idx === i); });
  }
  prev && prev.addEventListener('click', function(){ go(i - 1); });
  next && next.addEventListener('click', function(){ go(i + 1); });
  dots.forEach(function(d){ d.addEventListener('click', function(){ go(parseInt(d.dataset.i, 10)); }); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nh-pdpv2-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  var thumbs = document.querySelectorAll('[data-nh-thumb]');
  var main = document.querySelector('.nh-pdpv2-hero__img');
  if(!main || !thumbs.length) return;
  thumbs.forEach(function(t){
    t.addEventListener('click', function(){
      thumbs.forEach(function(x){x.classList.remove('is-active');});
      t.classList.add('is-active');
      main.src = t.dataset.src;
      main.srcset = '';
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nh-rx-buybox"] && !Shopify.designMode) return;
  try {
    
(function(){
  var sticky = document.querySelector('[data-rx-sticky]');
  if(!sticky) return;
  // Show after user has scrolled 30% of page
  function check(){
    var doc = document.documentElement;
    var pct = (window.scrollY) / (doc.scrollHeight - window.innerHeight);
    if(pct > 0.18 && pct < 0.95){ sticky.classList.add('is-visible'); sticky.setAttribute('aria-hidden','false'); }
    else { sticky.classList.remove('is-visible'); sticky.setAttribute('aria-hidden','true'); }
  }
  window.addEventListener('scroll', check, { passive:true });
  check();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nh-rx-diagnostic"] && !Shopify.designMode) return;
  try {
    
(function(){
  var diag = document.querySelector('[data-nh-rx-diag]');
  if(!diag) return;
  var stored = null;
  try{ stored = localStorage.getItem('nh-pain'); }catch(e){}
  if(stored){ document.documentElement.setAttribute('data-nh-pain', stored); diag.style.display = 'none'; }

  diag.querySelectorAll('[data-nh-pain]').forEach(function(b){
    b.addEventListener('click', function(){
      var k = b.getAttribute('data-nh-pain');
      document.documentElement.setAttribute('data-nh-pain', k);
      try{ localStorage.setItem('nh-pain', k); }catch(e){}
      diag.style.transition='opacity .35s';
      diag.style.opacity='0';
      setTimeout(function(){ diag.style.display='none'; window.scrollTo({top:0,behavior:'instant'}); }, 360);
    });
  });
  var skip = diag.querySelector('[data-nh-pain-skip]');
  skip && skip.addEventListener('click', function(){
    document.documentElement.setAttribute('data-nh-pain', 'all');
    try{ localStorage.setItem('nh-pain', 'all'); }catch(e){}
    diag.style.transition='opacity .35s';diag.style.opacity='0';
    setTimeout(function(){ diag.style.display='none'; }, 360);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nh-rx-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-rx-scroll]').forEach(function(b){
    b.addEventListener('click', function(){ window.scrollBy({top:window.innerHeight,behavior:'smooth'}); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nh-rx-sequence"] && !Shopify.designMode) return;
  try {
    
(function(){
  var frames = document.querySelectorAll('[data-rx-frame]');
  if(!frames.length || !('IntersectionObserver' in window)) {
    frames.forEach(function(f){f.classList.add('is-visible');});
    return;
  }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting) e.target.classList.add('is-visible'); });
  }, { threshold: 0.35 });
  frames.forEach(function(f){ io.observe(f); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nh-spotlight"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.nh-section--spotlight').forEach(function(root){
    var flavorRoot = root.querySelector('[data-nh-flavors]');
    var price = root.querySelector('[data-nh-price]');
    var idInput = root.querySelector('[data-nh-id]');
    var ctaLabel = root.querySelector('[data-nh-cta-label]');
    if(flavorRoot){
      flavorRoot.addEventListener('change', function(e){
        if(e.target.matches('input[type="radio"]')){
          flavorRoot.querySelectorAll('.nh-spot__flavor').forEach(function(el){ el.classList.remove('nh-spot__flavor--on'); });
          e.target.closest('label').classList.add('nh-spot__flavor--on');
          var p = e.target.dataset.price;
          if(idInput) idInput.value = e.target.value;
          if(p && price && window.Shopify && Shopify.formatMoney){
            var formatted = Shopify.formatMoney(parseInt(p,10), Shopify.money_format || '${{amount}}');
            price.textContent = formatted;
            if(ctaLabel) ctaLabel.textContent = ctaLabel.textContent.split(' — ')[0] + ' — ' + formatted;
          }
        }
      });
    }
    var subToggle = root.querySelector('[data-nh-sub-toggle]');
    if(subToggle){
      subToggle.addEventListener('click', function(e){
        var btn = e.target.closest('button[data-mode]');
        if(!btn) return;
        subToggle.querySelectorAll('button').forEach(function(b){ b.classList.remove('on'); b.setAttribute('aria-pressed','false'); });
        btn.classList.add('on');
        btn.setAttribute('aria-pressed','true');
      });
    }
    var qtyInput = root.querySelector('.nh-spot__qty input');
    root.querySelectorAll('.nh-spot__qty button[data-qty]').forEach(function(b){
      b.addEventListener('click', function(){
        if(!qtyInput) return;
        var v = parseInt(qtyInput.value,10) || 1;
        v = Math.max(1, v + parseInt(b.dataset.qty,10));
        qtyInput.value = v;
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nh-wpdp-carousel"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.querySelector('[data-nh-wcar]');
  if(!root) return;
  var track = root.querySelector('[data-nh-wcar-track]');
  var slides = track ? track.children : [];
  var dots = root.querySelectorAll('[data-nh-wcar-dot]');
  var prev = root.querySelector('[data-nh-wcar-prev]');
  var next = root.querySelector('[data-nh-wcar-next]');
  if(!track || !slides.length) return;
  var i = 0;
  function go(n){
    i = (n + slides.length) % slides.length;
    track.style.transform = 'translateX(-' + (i * 100) + '%)';
    dots.forEach(function(d, idx){ d.classList.toggle('is-active', idx === i); });
  }
  prev && prev.addEventListener('click', function(){ go(i - 1); });
  next && next.addEventListener('click', function(){ go(i + 1); });
  dots.forEach(function(d){ d.addEventListener('click', function(){ go(parseInt(d.dataset.i, 10)); }); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nh-wpdp-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  var thumbs = document.querySelectorAll('[data-nh-wthumb]');
  var main = document.querySelector('.nh-wpdp-hero__img');
  if(!main || !thumbs.length) return;
  thumbs.forEach(function(t){
    t.addEventListener('click', function(){
      thumbs.forEach(function(x){x.classList.remove('is-active');});
      t.classList.add('is-active');
      main.src = t.dataset.src;
      main.srcset = '';
    });
  });
})();

(function(){
  var idInput = document.querySelector('[data-nh-id]');
  var radios = document.querySelectorAll('[data-nh-variant]');
  if(!idInput || !radios.length) return;
  var pOne = document.querySelector('[data-nh-price-onetime]');
  var pSub = document.querySelector('[data-nh-price-sub]');
  radios.forEach(function(r){
    r.addEventListener('change', function(){
      idInput.value = r.value;
      if(pOne && r.dataset.onetime) pOne.textContent = r.dataset.onetime;
      if(pSub && r.dataset.sub) pSub.textContent = r.dataset.sub;
      document.querySelectorAll('.nh-wpdp-hero__variant').forEach(function(l){ l.classList.remove('is-active'); });
      var lab = r.closest('.nh-wpdp-hero__variant'); if(lab) lab.classList.add('is-active');
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
